import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";
import Radio from "@mui/material/Radio";
import { useDispatch } from "react-redux";
import { actionInfoPDFDownload } from "./InfoRedux";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import Button from "@mui/material/Button";

const root_ = (theme) => ({
  "& .MuiPaper-root.MuiDialog-paper": {
    width: 400,
  },
});

const title_ = (theme) => ({
  textAlign: "center",
});

const radio_ = (theme) => ({
  margin: "8px",
  textAlign: "center",
  "& .MuiButtonBase-root.MuiButtonBase-root": {
    padding: "2px",
  },
});

const faIconButton_ = (theme) => ({
  color: "black",
  backgroundColor: "#E0E0E0",
  margin: "4px",
  "& svg": {
    marginRight: "8px",
  },
});

const floors_ = (theme) => ({
  margin: "10px",
  marginBottom: "30px",
  textAlign: "center",
});

// Styled to look like a <a> link would.
const linkItem_ = (theme) => ({
  color: "primary.main",
  textDecoration: "underline",
  whiteSpace: "nowrap",
  "&:hover": {
    color: "primary.dark",
  },
});

export default function PDFDownloadDialog({
  open,
  onClose,
  bldrecnbr,
  name,
  floor,
}) {
  const dispatch = useDispatch();
  const titleStyle = { backgroundColor: "rgba(0, 0, 0, 0.05)" };
  const progressStyle = { position: "absolute", top: "50%", left: "45%" };
  const floorStr = floor ? `(Floor ${floor})` : "";

  const [isLoading, setIsLoading] = useState(true);

  const [pdfType, setPdfType] = useState("white");
  const handleRadioChange = (event) => {
    setPdfType(event.target.value);
  };

  const handleClose = () => {
    setIsLoading(false);
    onClose();
  };

  const [downloadData, setDownladData] = useState(null);
  useEffect(() => {
    if (open && bldrecnbr) {
      dispatch(
        actionInfoPDFDownload(bldrecnbr, (data) => {
          setDownladData(data);
          setIsLoading(false);
        }),
      );
    }
  }, [open, bldrecnbr, dispatch]);

  return (
    <Dialog
      sx={root_}
      onClose={handleClose}
      aria-labelledby="pdf-download"
      open={open}
      scroll="paper"
    >
      <DialogTitle sx={title_} style={titleStyle}>
        PDF Download - {name} {floorStr}
      </DialogTitle>
      <DownloadFormatInput
        pdfType={pdfType}
        handleRadioChange={handleRadioChange}
        isLoading={isLoading}
      />
      <FloorList pdfType={pdfType} downloadData={downloadData} floor={floor} />
      {isLoading && <CircularProgress style={progressStyle} />}
    </Dialog>
  );
}

function DownloadFormatInput({ pdfType, handleRadioChange, isLoading }) {
  return (
    <Box sx={radio_}>
      <FormControl variant="standard" component="fieldset">
        <RadioGroup
          aria-label="gender"
          name="pdf-type"
          value={pdfType}
          onChange={handleRadioChange}
        >
          <FormControlLabel
            value="white"
            control={<Radio color="primary" disabled={isLoading} />}
            label="Black & White"
          />
          <FormControlLabel
            value="rmtyp"
            control={<Radio color="primary" disabled={isLoading} />}
            label="Room Type"
          />
          <FormControlLabel
            value="deptid"
            control={<Radio color="primary" disabled={isLoading} />}
            label="Department"
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}

function FloorList({ downloadData, pdfType, floor }) {
  const isValid = !(
    !downloadData ||
    !downloadData[pdfType] ||
    !downloadData[pdfType].length
  );
  const data = isValid ? downloadData[pdfType] : [];
  const formatted = data.map((entry) => {
    const newEntry = {};
    for (let floor in entry) {
      newEntry["floor"] = floor;
      newEntry["url"] = entry[floor];
    }
    return newEntry;
  });
  const filtered = floor
    ? formatted.filter((entry) => entry.floor === floor)
    : formatted;
  const openLink = (url) => (event) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <Box sx={floors_}>
      {filtered.map((entry) => {
        return (
          <Button
            onClick={openLink(entry.url)}
            tabindex=""
            key={entry.floor}
            variant="contained"
            size="small"
            sx={faIconButton_}
          >
            <FontAwesomeIcon icon={faExternalLinkAlt} />
            <Box sx={linkItem_}>{`FlOOR ${entry.floor}`}</Box>
          </Button>
        );
      })}
    </Box>
  );
}
